// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1QWdk","title":"Header_title__8pKpE","left":"Header_left__3jKg9","clinicName":"Header_clinicName__30s_m"};